<template>
  <div class="home">
    <Header></Header>
    <div class="banner">
      <div class="banner-content">
        <div class="left-banner">
          <div class="title">使用文档</div>
          <div class="content">如何快速开始使用沐桦科技动态代理网络 采集类业务定制。</div>
        </div>
        <div class="right-banner">
          <img
            class=""
            src="./../assets/useDoc/banner.png"
            alt="沐桦科技"
          />
        </div>
      </div>
    </div>
    <section class="compare">
      <div class="muhua-title">使用说明</div>
      <div class="content">用户使用分布式代理IP时，只需要指定网关（ProxyGateway）及端口并对目标资源发起访问，即可实现以分布式IP为代理的目标访问。代理网关的一个端口映射一台雾计算设备的IP，这种映射关系由平台调度策略维护，平台同时保证用户的高可用和定制化。</div>
      <div class="content second-content">代理网关（ProxyGateway）以域名的方式提供，每个域名后端对应着多台代理网关服务器，确保用户接入的可用性。举例代理网关域名如下表：</div>
      <el-table
        :data="useInfo"
        border
        style="width: 80%;max-width: 600px;margin: 0 auto 54px"
        class="compare-table"
      >
        <el-table-column
          prop="region"
          label="区域"
          width="120px"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="代理网关于域名"
        >
        </el-table-column>
        <el-table-column
          prop="position"
          label="代理网关位置"
        >
        </el-table-column>
      </el-table>
    </section>
    <section class="demo">
      <div class="muhua-title">具体使用实例</div>
      <div class="demo-detail">
        <span class="circle"></span>
        <span class="circle yellow"></span>
        <span class="circle green"></span>
      </div>
      <div class="detail">
        <div># 使用单一代理网关访问目标地址（指定一个$port，会 映射到一个代理IP） </div>
        <div># $port_gw: 代理网关地址，例如：cn-north01.proxy.muhuakeji.com</div>
        <div># $port: 代理网关端口 </div>
        <div class="default first-bottom">curl -x $proxy_gw:$port http://www.target.com</div>

        <div># 使用代理网关批量访问目标地址 </div>
        <div># $port_start: 起始端口号 </div>
        <div># $port_end: 终止端口号 </div>
        <div># curl -m 3 单次爬取超时时间设置为3秒 </div>
        <div># status_code: 单次爬取返回http状态码 </div>
        <div># time_total: 单次爬取所用的时长, 单位：秒 </div>
        <div><span class="code">for port in `<span class="pink">seq</span> $port_start $port_end` </span></div>
        <div><span class="code">do</span></div>
        <div><span class="code">&nbsp;&nbsp;&nbsp;&nbsp;<span class="pink">echo</span> -n "port: $port “</span></div>
        <div><span class="code">&nbsp;&nbsp;&nbsp;&nbsp;curl -s -m 3 -x $proxy_gw_ipaddr:$port -w "status_code:%{http_code} time_total:%{time_total} \n" -o ./tt http://www.target.com</span></div>
        <div><span class="code">done</span></div>
      </div>
    </section>
    <section class="agent">
      <div class="muhua-title">变更代理IP</div>
      <div class="card-wrap">
        <div class="interface">
          <div>
            <div>【接口地址】http://api.proxy.muhuakeji.com:8080/proxy/changeip </div>
            <div>【请求头部】Content-Type:application/json </div>
          </div>
          <div class="second-wrap">
            <div>【请求方法】POST </div>
            <div>【请求参数】见下表</div>
          </div>
        </div>

        <el-table
          :data="changeIp"
          style="margin: 20px auto 54px"
          class="compare-table"
        >
          <el-table-column
            prop="name"
            label="名称"
          >
          </el-table-column>
          <el-table-column
            prop="type"
            label="类型"
          >
          </el-table-column>
          <el-table-column
            prop="status"
            label="必填"
          >
          </el-table-column>
          <el-table-column
            prop="explain"
            label="说明"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="card-wrap">

        <div class="card">
          <div class="title">【响应结果】正常返回结果</div>

          <div class="detail">
            <div>&nbsp;&nbsp; # 变更操作正常，返回替换后端口与代理IP的关系 </div>
            <div>&nbsp;&nbsp; <span class="code">{“ProxyIps": </span></div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp; <span class="code">[{ </span></div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="code">"port":10000,</span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;# 映射端口
            </div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="code">"int_ip":"fdff:4243:4c4f:5544:3000:0:19:11fd", </span>&nbsp;&nbsp;&nbsp;# 切换后雾计算节点的内网IPv6地址 </div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="code">"ext_ip":"113.59.225.188" </span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              # 切换后雾计算节点的公网IPv4地址
            </div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp; <span class="code">}, </span></div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp; <span class="code">{ </span></div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="code">"port":10001,</span></div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="code">"int_ip":"fdff:4243:4c4f:5544:3000:0:18:1017", </span>&nbsp;&nbsp;&nbsp; # 切换后雾计算节点的内网IPv6地址 </div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="code">"ext_ip":"39.98.38.140" </span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              # 切换后雾计算节点的公网IPv4地址
            </div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp; <span class="code">}] </span></div>
            <div>&nbsp;&nbsp; <span class="code">} </span></div>
          </div>
        </div>
      </div>
      <div class="card-wrap">
        <div class="card">
          <div class="title">【Token错误返回结果</div>
          <div class="detail">
            <div>{"code":403,"details":"authority check failed"}</div>
          </div>
        </div>
      </div>

    </section>
    <section class="change-demo">
      <div class="muhua-title">变更代理IP代码示例</div>
      <div class="demo-detail"></div>
      <div class="detail">
        <div> !/usr/bin/env python </div>
        <div> # -*- encoding:utf-8 -*- </div>
        <div> import sys </div>
        <div> import md5 </div>
        <div> import json </div>
        <div> import requests </div>

        <div> # 代理网关的IP地址 </div>
        <div> proxy_gw_ipaddr_v4 = "xxx.xxx.xxx.xxx" </div>
        <div> # 用户UUID </div>
        <div> uuid = “xxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" </div>
        <div> # 需要变更IP的代理端口列表 </div>

        <div> ports = [10000, 10001] </div>
        <div> # 代理网关IP地址转换为整形 </div>
        <!-- <div class="green"> ch = lambda x:sum(&#91256**j*int(i) for j,i in enumerate(x.split('.')&#91::-1])]) proxy_gw_ipaddr_int = ch(proxy_gw_ipaddr_v4) </div>
        <div class="green"> # 代理网关IP地址的整数形式转换为16进制字符串 </div>
          proxy_gw_ipaddr_hex = hex(proxy_gw_ipaddr_int) proxy_gw_ipaddr_str = str(proxy_gw_ipaddr_hex).upper().replace("0X","") </div>
        <div class="green"> # 生成token：代理网关IP地址的16进制字符串与UUID组合的MD5值 </div>
          m1 = md5.new() m1.update(proxy_gw_ipaddr_str+uuid) token = m1.hexdigest().upper() </div>
          # 调用接口变更指定代理的端口映射IP </div>
        <div class="green"> # 注意：api域名不同于代理网关的域名 
          url="http://api.proxy.muhuakeji.com:8080/proxy/changeip" headers = {"Content-Type": "application/json"} data = { "ports": ports, 
        <div class="green"> # 需要变更IP的映射端口 </div>
          "ip": proxy_gw_ipaddr_v4, </div>
        <div class="green"> # 指定代理接入点的IP地址 </div>
        <div class="green"> "token": token # 生成的token } r = requests.post(url, headers = headers, data = json.dumps(data)) res = json.loads(r.text) for one in res&#91"ProxyIps"]: print one</div> -->
      </div>
    </section>
    <section class="product-detail height-220">
      <div class="muhua-title advantage-title">了解如何使用沐桦动态代理网络服务</div>
      <div class="detail-wrap">
        <router-link to="/ipDetail" class="button compute">了解动态代理</router-link>
        <router-link to="/customerCase" class="button compute white-button">查看案例</router-link>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from "vuex";
import Footer from "@/components/Footer.vue";
import Menu from "@/components/Menu.vue";
import Header from "@/components/Header.vue";

export default {
  name: "home",
  components: {
    Footer,
    Header
  },
  data() {
    return {
      activeIndex: '3',
      useInfo: [
        {
          region: "华北",
          name: "cn-north01.proxy.muhuakeji.com",
          position: "北京"
        },
        {
          region: "华东",
          name: "cn-east01.proxy.muhuakeji.com",
          position: "上海"
        },
        {
          region: "华南",
          name: "cn-south01.proxy.muhuakeji.com",
          position: "广州"
        }
      ],
      changeIp: [
        {
          name: "ip",
          type: "string",
          status: "是",
          explain:
            "代理网关IP地址 （在用户购买服务后会有专享的代理网关，并以该IP地址的方式提供信息）"
        },
        {
          name: "token",
          type: "string",
          status: "是",
          explain:
            "授权认证码 （在购买服务后会提供用户UUID，token由用户UUID经过算法转换生成，详 见下面的代码示例）"
        },
        {
          name: "ports",
          type: "int&#91]",
          status: "是",
          explain:
            "需要进行代理IP替换的映射端口， （每个端口映射一个代理IP，用户指定的端口所映射的代理IP会被替 换；该参数为数组，可以一次替换多个端口，默认上限为100个端口，如果不 符合的需求，请与客服联系）"
        }
      ]
    };
  }
};
</script>

<style scoped lang="stylus">
.change-demo {
  background: rgba(248, 252, 255, 1);
  padding-bottom: 45px;
}

.agent {
  background: rgba(255, 255, 255, 1);
  text-align: left;

  .card-wrap {
    width: 80%;
    max-width: 800px;
    margin: 0 auto 34px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.06);
    border-radius: 5px;
    padding: 20px;
    font-size: 9px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(40, 47, 60, 1);
    line-height: 22px;

    .second-wrap {
      margin-left: 60px;
    }

    .interface {
      display: flex;
      line-height: 25px;
    }
  }

  .second-card {
    margin-bottom: 34px;
  }

  .title {
    margin: 18px 0 13px;
    font-weight: bold;
  }
}

.demo-detail {
  max-width: 800px;
  height: 27px;
  background: rgba(63, 79, 124, 1);
  border-radius: 2px 2px 0px 0px;
  border: 1px solid rgba(63, 79, 124, 0.2);
  margin: 0 auto;
  padding: 0 14px;

  .circle {
    display: inline-block;
    width: 9px;
    height: 9px;
    background: rgba(255, 96, 88, 0.7);
    border: 1px solid rgba(255, 97, 89, 0.7);
    margin: 9px 5px;
    border-radius: 9px;
  }

  .yellow {
    border: 1px solid #FFC02E;
    background: #FFC02E;
  }

  .green {
    background: #27CA41;
    border: 1px solid #27CA41;
  }
}

.detail {
  max-width: 800px;
  margin: 0 auto;
  padding: 13px 14px;
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  border: 1px solid rgba(63, 79, 124, 0.2);
  color: #468C32;
  font-size: 8px;
  margin-bottom: 45px;
  line-height: 28px;

  .default {
    color: #282F3C;
  }

  .first-bottom {
    margin-bottom: 20px;
  }

  .code {
    color: #748598;
  }

  .pink{
    color: #ED61A8;
  }
}

.demo {
  background: rgba(248, 252, 255, 1);
  padding-bottom: 45px;
}

.banner {
  background: #282A3C;
  width: 100%;
  height: 400px;
  display: flex;

  .banner-content {
    width: 80%;
    margin: 0 auto;
    display: flex;
    max-width: 1200px;
  }

  .left-banner {
    width: 59%;

    .title {
      margin: 121px 0 19px 0;
      font-size: 38px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: #fff;
      line-height: 64px;
    }

    .content {
      width: 383px;
      height: 90px;
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      line-height: 23px;
      margin-bottom: 27px;
      font-size: 18px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: #fff;
      line-height: 32px;
    }

    .know-more {
      width: 96px;
      height: 31px;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      font-size: 11px;
      font-weight: 400;
      color: rgba(40, 42, 60, 1);
      line-height: 20px;
      text-align: center;
      line-height: 31px;
    }
  }

  .right-banner {
    width: 41%;

    img {
      height: 400px;
    }
  }
}

.product-detail {
  background-image: url('../assets/background/white_point.png');
  background-size: cover;

  .detail-wrap {
    display: flex;
    justify-content: space-between;
    width: 327px;
    margin: 0 auto;
  }

}

.compare {
  background: rgba(255, 255, 255, 1);
  text-align: center;
  margin: 0 auto;

  img {
    width: 514px;
    height: 181px;
    margin-bottom: 50px;
  }

  .muhua-title {
    padding: 34px 0 9px;
  }

  .content {
    margin: 0 auto;
    font-size: 10px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(116, 133, 152, 1);
    line-height: 30px;
    width: 80%;
    max-width: 800px;
  }

  .second-content {
    margin: 13px auto 23px;
  }

  .compare-table {
    max-width: 540px;
    margin: 0 auto 54px;
  }
}
</style>
